@use '@fukuri-admins/ui/layout' as *;

.ErrorMessages {
  padding: 0;
  margin: 0;

  &__MessageItem {

    &__Message {
      color: $TextError;
      font-size: 12px;
      line-height: 16px;
      font-weight: 400;
    }
  }
}
